import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BoxscoreTeamTable from './boxscoreTeam/BoxscoreTeamTable';
import BoxscoreInfo from './boxscoreTeam/BoxscoreInfo';
import BoxscoreTeamNotes from './boxscoreTeam/BoxscoreTeamNotes';
import BoxscoreTypes from './boxscoreTeam/boxscoreTeamTable/config/BoxscoreTypes';
import { GameInfoWrapper, GameInfo } from '../Boxscore.style';
import FieldList from './boxscoreTeam/boxscoreInfo/FieldList';

import {
    BoxscoreTeamNotesWrapper
} from './BoxscoreTeam.style';
const { BATTING, PITCHING, BATTERS, PITCHERS, BENCH, BULLPEN } = BoxscoreTypes;

const BoxscoreTeam = ({
    team = '',
    language = 'en',
    lineups = {},
    teamStats = {},
    isInProgress = false,
    teamAbbreviation = '',
    syncBoxscoreInfo,
    expanded,
    showBench,
    showBullpen,
    list,
    displayGameInfoInline
}) => {
    const { info = [], note = [] } = lineups;

    return (
        <Fragment>
            <BoxscoreTeamTable
                type={ BATTING }
                language={ language }
                team={ teamAbbreviation }
                lineups={ lineups.battingOrderAll }
                teamStats={ teamStats[BATTING] }
                isInProgress={isInProgress}
                className={`${team}-r1`}
                headerType={ BATTERS }
            />
            {note.length > 0 && <BoxscoreTeamNotesWrapper className={`${team}-r2`}>
                {note.map((data, index) => {
                    const { label, value } = data;
                    return (
                        <BoxscoreTeamNotes key={`teamnote-${index}`} label={label} value={value} index={index} />
                    );
                })
                }
            </BoxscoreTeamNotesWrapper>}
            <BoxscoreInfo
                info={info}
                initOpen={expanded}
                className={`${team}-r3`}
                handlers={{ onClick: syncBoxscoreInfo }}
                expandedFromTop={expanded}
                enableToggle={false}
            />
            <BoxscoreTeamTable
                type={ PITCHING }
                team={ teamAbbreviation }
                lineups={ lineups.pitchers }
                teamStats={ teamStats[PITCHING] }
                isInProgress={ isInProgress }
                className={`${team}-r4`}
                headerType={ PITCHERS }
                language={ language }
            />

            {displayGameInfoInline && <GameInfoWrapper className={`${team}-rgameInfo`}>
                <GameInfo
                    visibleContent={ <FieldList list={list} divider={': '} /> }
                    showButton={ false }
                />
            </GameInfoWrapper>}

            {showBench && <BoxscoreTeamTable
                type={ BENCH }
                team={ teamAbbreviation }
                lineups={ lineups.bench }
                teamStats={{}}
                isInProgress={ isInProgress }
                className={`${team}-r5`}
                headerType={ BENCH }
                language={ language }
            />}

            {showBullpen && <BoxscoreTeamTable
                type={ BULLPEN }
                team={ teamAbbreviation }
                lineups={ lineups.bullpen }
                teamStats={{}}
                isInProgress={ isInProgress }
                className={`${team}-r6`}
                headerType={ BULLPEN }
                language={ language }
            />
            }

        </Fragment>
    );
};

BoxscoreTeam.propTypes = {
    lineups: PropTypes.object,
    language: PropTypes.string,
    team: PropTypes.string,
    teamStats: PropTypes.object,
    teamAbbreviation: PropTypes.string,
    syncBoxscoreInfo: PropTypes.func,
    expanded: PropTypes.bool,
    isInProgress: PropTypes.bool,
    showBench: PropTypes.bool,
    showBullpen: PropTypes.bool,
    list: PropTypes.array,
    displayGameInfoInline: PropTypes.bool
};

export default BoxscoreTeam;
